import React from 'react'
import './Login.css'
import { Button } from '@mui/material'
import PoolIcon from '@mui/icons-material/Pool';
import { auth, provider } from "./firebase"
import { useStateValue } from "./StateProvider"
import { actionTypes } from "./reducer"
 
function Login() {
const [state, dispatch] = useStateValue()


    const signIn = () => {
        
       

        auth
            .signInWithPopup(provider.setCustomParameters({
                prompt: 'select_account'
            }))
            .then(result => {

                dispatch({
                    type: actionTypes.SET_USER,
                    user: result.user
                }) 
            })
            .catch(error => {
                alert(error.message)
            })
    }



  return (
    <div className='login'>
        <div className="login__container">
       <PoolIcon className="login__poolicon" />
        <h1>~WavPool~ Chat</h1>
        <p>Please sign in</p>
        <Button onClick ={signIn}>Sign in with Google</Button>
        </div>
        
    </div>
  )
}

export default Login